/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The IntegrationsformsortFormsortIntegration1 model module.
 * @module model/IntegrationsformsortFormsortIntegration1
 * @version v0.3
 */
export default class IntegrationsformsortFormsortIntegration1 {
  /**
   * Constructs a new <code>IntegrationsformsortFormsortIntegration1</code>.
   * @alias module:model/IntegrationsformsortFormsortIntegration1
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationsformsortFormsortIntegration1</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsformsortFormsortIntegration1} obj Optional instance to populate.
   * @return {module:model/IntegrationsformsortFormsortIntegration1} The populated <code>IntegrationsformsortFormsortIntegration1</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsformsortFormsortIntegration1();
      if (data.hasOwnProperty('signing_key'))
        obj.signingKey = ApiClient.convertToType(data['signing_key'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} signingKey
 */
IntegrationsformsortFormsortIntegration1.prototype.signingKey = undefined;

/**
 * @member {Boolean} enabled
 */
IntegrationsformsortFormsortIntegration1.prototype.enabled = undefined;

